import { Subscription } from 'rxjs';

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IDropdownSettings, NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { HandleError } from '../../../core/models/handle-error';
import { AuthService } from '../../../core/services/auth/auth.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { VideosService } from '../../videos/videos.service';

import { APP_SETTINGS } from '@services';
import { BMWListData } from '../../../core/models/bmwListData';
import { MINIListData } from '../../../core/models/miniListData';
import { MOTORRADListData } from '../../../core/models/motorradListData';
import { NoiseCatalogFilterRequest } from '../../../core/models/noiseCatalogFilterRequest';
import { NoiseCatalogParamsRefDataResponse } from '../../../core/models/noiseCatalogParamsRefDataResponse';
import { ResultStatus } from '../../../core/models/resultStatus';
import { AnalyticsService } from '../../../core/services/analytics/analytics.service';
import { CmsNavbarService } from '../../cms-navbar/cms-navbar.service';
import { ModelMapService } from '../../model-map/model-map.service';
import { NoiseCatalogService } from '../noise-catalog.service';
import { NgIf, NgFor, NgClass, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { NoiseCatalogShareContentComponent } from '../../noise-catalog-share-content/noise-catalog-share-content.component';
import { SearchFilterPipe } from '../../../shared/pipes/search-filter.pipe';
import { HighlightSearchPipe } from '../../../shared/pipes/highlight-search.pipe';
import { LoadMoreItemsPipe } from '../../../shared/pipes/load-more-items.pipe';

@Component({
    selector: 'app-noise-catalog-home',
    templateUrl: './noise-catalog-home.component.html',
    styleUrls: ['./noise-catalog-home.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        FormsModule,
        NgFor,
        NgMultiSelectDropDownModule,
        NgClass,
        RouterLink,
        NoiseCatalogShareContentComponent,
        DatePipe,
        SearchFilterPipe,
        HighlightSearchPipe,
        LoadMoreItemsPipe,
    ],
})
export class NoiseCatalogHomeComponent implements OnInit, OnDestroy {

  public newNoisecatalog: any;
  public screenWidth: any;
  private subscription: Subscription[] = [];
  public noisecatalogshareContentObject = {};
  public serviceError = 'Loading data. Please wait...';
  public dateFormat: string;
  APP_SETTINGS : any;
  public searchClick: boolean;

  // public large_bmw_image = "assets/images/C100_200px_BMW_RGB72DPI.png";
  public large_bmw_width = "150px";
  public large_bmw_height = "150px";
  public videoThumbnail =  APP_SETTINGS.isMINI === 'true' ? APP_SETTINGS.miniVideoThumbnail : APP_SETTINGS.isRollsRoyce === 'true' ? APP_SETTINGS.rollsRoyceVideoThumbnail :  APP_SETTINGS.videoThumbnail;
  public videoThumbnailHeight = APP_SETTINGS.videoThumbnailHeight;
  public videoThumbnailWidth = APP_SETTINGS.videoThumbnailWidth;

  @ViewChild('modalCloseButton')
  private modalCloseButtonEle: ElementRef;

  username: string;
  public moreItems = 24;

  constructor(
    private utilityService: UtilityService,
    private cmsNavbarService: CmsNavbarService,
    private spinnerService: SpinnerService,
    private videoService: VideosService,
    private noisecatalogService: NoiseCatalogService,
    private authService: AuthService,
    //private toastService: ToastConfigService,
    private toastService: ToastrService,
    private analyticsService: AnalyticsService,
    private modelMapService: ModelMapService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }
  dropdownESeriesList = [];
  dropdownAreaList = [];
  dropdownComponentList = [];
  dropdownDrivingConditionList = [];
  dropdownKindOfNoiseList = [];
  dropdownWeatherConditionList = [];
  selectedItems = [];
  BMW?: BMWListData;
  MINI?: MINIListData;
  MOTORRAD?: MOTORRADListData;
  prevMake?: string;
  currentMake?: string;
  makeSelected?: string;

  public areaList: any[];
  public areaFilterList: string[];
  public componentList: any[];
  public componentFilterList: string[];
  public drivingConditionList: any[];
  public drivingConditionFilterList: string[];
  public weatherConditionList: any[];
  public weatherConditionFilterList: any[];
  public kindOfNoiseList: any[];
  public kindOfNoiseFilterList: any[];
  public noiseCatalogParamsRefDataResponse: NoiseCatalogParamsRefDataResponse;

  public sproadicPermanentList = [];
  // public seriesList: any[];
  // public seriesFilterList: string[];

  public seriesList: any[];
  public seriesFilterList: any[];

  public inputSeries = '';
  public inputModel = '';
  public inputEngine = '';

  public inputSproadicPermanent: any;
  public inputArea = '';
  public inputComponent = '';
  public inputDrivingCondition = '';
  public inputWeatherCondition = '';
  public inputKindOfNoise = '';
  public inputChannel: any;
  public channelsList = [];


  dropdownSettingsSeries: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'seriesName',
    itemsShowLimit: 25,
    limitSelection: 25,
    allowSearchFilter: true,
    enableCheckAll: false,
    clearSearchFilter: true,
    noDataAvailablePlaceholderText: 'No data available',
    searchPlaceholderText: 'Search',
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    defaultOpen: false
  };

  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    itemsShowLimit: 25,
    limitSelection: 25,
    allowSearchFilter: true,
    enableCheckAll: false,
    clearSearchFilter: true,
    noDataAvailablePlaceholderText: 'No data available',
    searchPlaceholderText: 'Search',
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    defaultOpen: false,
  };


  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.makeSelected = "BMW";
    this.searchClick = false;
    this.areaList = [];
    this.componentList = [];
    this.componentFilterList = [];
    this.drivingConditionList = [];
    this.weatherConditionList = [];
    this.kindOfNoiseList = [];
    this.sproadicPermanentList = [];
    // set image details here. hopefully improves performance
    this.subscription = [];
    this.username = this.authService.getUserName();
    APP_SETTINGS.currentPage = 'videos';
    this.dateFormat = 'yyyy-MM-dd';
    let noiseCatalogFilterRequest = new NoiseCatalogFilterRequest();

    if (sessionStorage.getItem('noiseCatalogFilterRequest')) {
      noiseCatalogFilterRequest = JSON.parse(sessionStorage.getItem('noiseCatalogFilterRequest'));
    }
    else {
      this.spinnerService.show('bmwSpinner');
      this.subscription.push(this.noisecatalogService.getNoiseCatalogData().subscribe(value => {

        this.spinnerService.hide('bmwSpinner');
        this.newNoisecatalog = value.noiseCatalogList;

      },
        error => {
          this.spinnerService.hide('bmwSpinner');
          this.serviceError = HandleError.handleAPIError(error);
        }
      ));
    }

    this.subscription.push(this.utilityService.shareContentPopup$.subscribe(data => {
      if (typeof data === 'boolean') {
        this.modalCloseButtonEle.nativeElement.click();
      }

    }));

    this.subscription.push(this.cmsNavbarService.getMainGroupsList().subscribe(data => {
      this.channelsList = data;
      if (sessionStorage.getItem('noiseCatalogFilterRequest')) {
        this.inputChannel = this.channelsList.find(channel => channel['mainGroupName'] === noiseCatalogFilterRequest.mainGroup);
      }
      this.changeDetector.detectChanges();
    }));

    this.subscription.push(this.modelMapService.getAllSeries().subscribe(data => {
      this.seriesList = data;
      this.dropdownESeriesList = this.seriesList;
      if (sessionStorage.getItem('noiseCatalogFilterRequest')) {
        this.seriesFilterList = filterSeriesArrayByName(this.seriesList, noiseCatalogFilterRequest.seriesFilterList);
      }
      this.changeDetector.detectChanges();
    }));

    this.subscription.push(this.noisecatalogService.findAllNoiseCatalogParamsRefData().subscribe(
      (data: NoiseCatalogParamsRefDataResponse) => {
        this.noiseCatalogParamsRefDataResponse = data;

      },
      (err: ResultStatus) => {
        console.error('Error retrieving all noise catalog data', err);
      },
      () => this.populateNoiseParamList()
    ));
  }

  prePopulateFilteredNoiseCatalogList() {

    if (sessionStorage.getItem('noiseCatalogFilterRequest')) {
      this.searchClick = false;
      let noiseCatalogFilterRequest = JSON.parse(sessionStorage.getItem('noiseCatalogFilterRequest'));
      this.inputSproadicPermanent = this.sproadicPermanentList.find(sproadicPermanent => sproadicPermanent === noiseCatalogFilterRequest.sporadicOrPermanent);

      this.areaFilterList = noiseCatalogFilterRequest.areaFilterList;

      this.componentFilterList = noiseCatalogFilterRequest.componentFilterList;

      this.drivingConditionFilterList = noiseCatalogFilterRequest.drivingConditionFilterList;

      this.weatherConditionFilterList = noiseCatalogFilterRequest.weatherConditionFilterList;

      this.kindOfNoiseFilterList = noiseCatalogFilterRequest.kindOfNoiseFilterList;

      if (noiseCatalogFilterRequest.mainGroup === undefined
        && noiseCatalogFilterRequest.sporadicOrPermanent === undefined
        && (noiseCatalogFilterRequest.seriesFilterList === undefined || noiseCatalogFilterRequest.seriesFilterList.length === 0)
        && (noiseCatalogFilterRequest.areaFilterList === undefined || noiseCatalogFilterRequest.areaFilterList.length === 0)
        && (noiseCatalogFilterRequest.componentFilterList === undefined || noiseCatalogFilterRequest.componentFilterList.length === 0)
        && (noiseCatalogFilterRequest.drivingConditionFilterList === undefined || noiseCatalogFilterRequest.drivingConditionFilterList.length === 0)
        && (noiseCatalogFilterRequest.weatherConditionFilterList === undefined || noiseCatalogFilterRequest.weatherConditionFilterList.length === 0)
        && (noiseCatalogFilterRequest.kindOfNoiseFilterList === undefined || noiseCatalogFilterRequest.kindOfNoiseFilterList.length === 0)
      ) {
        this.spinnerService.show('bmwSpinner');
        this.subscription.push(this.noisecatalogService.getNoiseCatalogData().subscribe(value => {
          this.spinnerService.hide('bmwSpinner');
          this.newNoisecatalog = value.noiseCatalogList;
          sessionStorage.setItem('noiseCatalogFilterRequest', JSON.stringify(noiseCatalogFilterRequest));
        },
          error => {
            this.spinnerService.hide('bmwSpinner');
            this.serviceError = HandleError.handleAPIError(error);
          }
        ));
      }
      else {
        this.spinnerService.show('bmwSpinner');
        this.subscription.push(this.noisecatalogService.getNoiseCatalogDataByFilter(noiseCatalogFilterRequest).subscribe(value => {
          this.spinnerService.hide('bmwSpinner');
          //this.newNoisecatalog = value.noiseCatalogList;
          this.newNoisecatalog = value;
          sessionStorage.setItem('noiseCatalogFilterRequest', JSON.stringify(noiseCatalogFilterRequest));
          this.analyticsService.trackClicksByNoiseCatalogSearchKeywordLineMake('Noise Catalog', noiseCatalogFilterRequest.mainGroup, noiseCatalogFilterRequest.sporadicOrPermanent
            , noiseCatalogFilterRequest.seriesFilterList, noiseCatalogFilterRequest.areaFilterList, noiseCatalogFilterRequest.componentFilterList
            , noiseCatalogFilterRequest.drivingConditionFilterList, noiseCatalogFilterRequest.weatherConditionFilterList, noiseCatalogFilterRequest.kindOfNoiseFilterList)
        },
          error => {
            this.spinnerService.hide('bmwSpinner');
            this.serviceError = HandleError.handleAPIError(error);
          }
        ));

      }

    }
  }

  populateFilteredNoiseCatalogList() {
    this.spinnerService.show('bmwSpinner');
    this.searchClick = true;
    let noiseCatalogFilterRequest = new NoiseCatalogFilterRequest();
    if (!((this.inputChannel === null || this.inputChannel === undefined || this.inputChannel === 'undefined'))) {
      noiseCatalogFilterRequest.mainGroup = this.inputChannel.mainGroupName;
    }

    if (!((this.inputSproadicPermanent === null || this.inputSproadicPermanent === undefined || this.inputSproadicPermanent === 'undefined'))) {
      noiseCatalogFilterRequest.sporadicOrPermanent = this.inputSproadicPermanent;
    }

    if (!((this.areaFilterList === null || this.areaFilterList === undefined))) {
      noiseCatalogFilterRequest.areaFilterList = this.areaFilterList.filter(Boolean);
    }
    if (!((this.componentFilterList === null || this.componentFilterList === undefined))) {
      noiseCatalogFilterRequest.componentFilterList = this.componentFilterList.filter(Boolean);
    }
    if (!((this.drivingConditionFilterList === null || this.drivingConditionFilterList === undefined))) {
      noiseCatalogFilterRequest.drivingConditionFilterList = this.drivingConditionFilterList.filter(Boolean);
    }
    if (!((this.weatherConditionFilterList === null || this.weatherConditionFilterList === undefined))) {
      noiseCatalogFilterRequest.weatherConditionFilterList = this.weatherConditionFilterList.filter(Boolean);
    }
    if (!((this.kindOfNoiseFilterList === null || this.kindOfNoiseFilterList === undefined))) {
      noiseCatalogFilterRequest.kindOfNoiseFilterList = this.kindOfNoiseFilterList.filter(Boolean);
    }
    if (!((this.seriesFilterList === null || this.seriesFilterList === undefined))) {
      const selectedSeries = filterSeriesArray(this.seriesList, this.seriesFilterList);
      noiseCatalogFilterRequest.seriesFilterList = selectedSeries.filter(Boolean);
    }

    if (noiseCatalogFilterRequest.mainGroup === undefined
      && noiseCatalogFilterRequest.sporadicOrPermanent === undefined
      && (noiseCatalogFilterRequest.seriesFilterList === undefined || noiseCatalogFilterRequest.seriesFilterList.length === 0)
      && (noiseCatalogFilterRequest.areaFilterList === undefined || noiseCatalogFilterRequest.areaFilterList.length === 0)
      && (noiseCatalogFilterRequest.componentFilterList === undefined || noiseCatalogFilterRequest.componentFilterList.length === 0)
      && (noiseCatalogFilterRequest.drivingConditionFilterList === undefined || noiseCatalogFilterRequest.drivingConditionFilterList.length === 0)
      && (noiseCatalogFilterRequest.weatherConditionFilterList === undefined || noiseCatalogFilterRequest.weatherConditionFilterList.length === 0)
      && (noiseCatalogFilterRequest.kindOfNoiseFilterList === undefined || noiseCatalogFilterRequest.kindOfNoiseFilterList.length === 0)
    ) {
      this.spinnerService.show('bmwSpinner');
      this.subscription.push(this.noisecatalogService.getNoiseCatalogData().subscribe(value => {
        this.spinnerService.hide('bmwSpinner');
        this.newNoisecatalog = value.noiseCatalogList;
        sessionStorage.setItem('noiseCatalogFilterRequest', JSON.stringify(noiseCatalogFilterRequest));
      },
        error => {
          this.spinnerService.hide('bmwSpinner');
          this.serviceError = HandleError.handleAPIError(error);
        }
      ));
    }
    else {
      this.spinnerService.show('bmwSpinner');
      this.subscription.push(this.noisecatalogService.getNoiseCatalogDataByFilter(noiseCatalogFilterRequest).subscribe(value => {
        this.spinnerService.hide('bmwSpinner');
        //this.newNoisecatalog = value.noiseCatalogList;
        this.newNoisecatalog = value;
        sessionStorage.setItem('noiseCatalogFilterRequest', JSON.stringify(noiseCatalogFilterRequest));
        this.analyticsService.trackClicksByNoiseCatalogSearchKeywordLineMake('Noise Catalog', noiseCatalogFilterRequest.mainGroup, noiseCatalogFilterRequest.sporadicOrPermanent
          , noiseCatalogFilterRequest.seriesFilterList, noiseCatalogFilterRequest.areaFilterList, noiseCatalogFilterRequest.componentFilterList
          , noiseCatalogFilterRequest.drivingConditionFilterList, noiseCatalogFilterRequest.weatherConditionFilterList, noiseCatalogFilterRequest.kindOfNoiseFilterList)

      },
        error => {
          this.spinnerService.hide('bmwSpinner');
          this.serviceError = HandleError.handleAPIError(error);
        }
      ));
    }

  }

  populateNoiseParamList() {

    if (this.noiseCatalogParamsRefDataResponse != null && this.noiseCatalogParamsRefDataResponse.status.statusCode === 'SUCCESS') {
      this.BMW = this.noiseCatalogParamsRefDataResponse.noiseCatalogDataParams.BMW;
      this.MINI = this.noiseCatalogParamsRefDataResponse.noiseCatalogDataParams.MINI;
      this.MOTORRAD = this.noiseCatalogParamsRefDataResponse.noiseCatalogDataParams.MOTORRAD;

      if (APP_SETTINGS.isBMW === 'true') {
        this.makeSelected = "BMW";
      }
      if (APP_SETTINGS.isMINI === 'true') {
        this.makeSelected = "MINI";
      }
      if (APP_SETTINGS.isMOTORRAD === 'true') {
        this.makeSelected = "MOTORRAD";
      }
      //this.prevMake = "BMW";
      // this.makeSelected = "BMW";
      // if (this.makeSelected === 'BMW') {
      this.populateNoiseParamListByMake(this.makeSelected);
      //   this.inputSproadicPermanent = this.sproadicPermanentList.find(sproadicPermanent => sproadicPermanent === 'Sporadic');
      // }

    }
  }

  populateNoiseParamListByMake(makeNameCurrent) {

    // this.resetFields();
    if (makeNameCurrent === 'BMW') {
      //this.inputMake = 'BMW';
      this.areaList = this.BMW.area;
      this.dropdownAreaList = this.areaList;
      this.componentList = this.BMW.component;
      this.dropdownComponentList = this.componentList;
      this.drivingConditionList = this.BMW.driveConditions;
      this.dropdownDrivingConditionList = this.drivingConditionList;
      this.weatherConditionList = this.BMW.weatherConditions;
      this.dropdownWeatherConditionList = this.weatherConditionList;
      this.kindOfNoiseList = this.BMW.kindOfNoise;
      this.dropdownKindOfNoiseList = this.kindOfNoiseList;
      this.sproadicPermanentList = this.BMW.sporadicOrPermanent;
    }
    else if (makeNameCurrent === 'MINI') {
      //  this.inputMake = 'MINI';
      this.areaList = this.MINI.area;
      this.dropdownAreaList = this.areaList;
      this.componentList = this.MINI.component;
      this.dropdownComponentList = this.componentList;
      this.drivingConditionList = this.MINI.driveConditions;
      this.dropdownDrivingConditionList = this.drivingConditionList;
      this.weatherConditionList = this.MINI.weatherConditions;
      this.dropdownWeatherConditionList = this.weatherConditionList;
      this.kindOfNoiseList = this.MINI.kindOfNoise;
      this.dropdownKindOfNoiseList = this.kindOfNoiseList;
      this.sproadicPermanentList = this.MINI.sporadicOrPermanent;
    }
    else if (makeNameCurrent === 'MOTORRAD') {
      //this.inputMake = 'MOTORRAD';
      this.areaList = this.MOTORRAD.area;
      this.dropdownAreaList = this.areaList;
      this.componentList = this.MOTORRAD.component;
      this.dropdownComponentList = this.componentList;
      this.drivingConditionList = this.MOTORRAD.driveConditions;
      this.dropdownDrivingConditionList = this.drivingConditionList;
      this.weatherConditionList = this.MOTORRAD.weatherConditions;
      this.dropdownWeatherConditionList = this.weatherConditionList;
      this.kindOfNoiseList = this.MOTORRAD.kindOfNoise;
      this.dropdownKindOfNoiseList = this.kindOfNoiseList;
      this.sproadicPermanentList = this.MOTORRAD.sporadicOrPermanent;
    }
    if (sessionStorage.getItem('noiseCatalogFilterRequest')) {
      this.prePopulateFilteredNoiseCatalogList();
    }
  }

  addNoiseCatalogToWatchlist(noisecatalogId, noiseCatalogDisplayNumber) {
    //Analytics call
    this.analyticsService.trackSavedContentByTypeLineMake('Noise Catalog', noiseCatalogDisplayNumber, 'saved');
    //Analytics call
    this.noisecatalogService.addNoiseCatalogToWatchlist(this.username, noisecatalogId).subscribe(data => {
      if (data) {
        this.toastService.success('Noise Catalog added to watchlist', 'Success', {
          closeButton: true,
          timeOut: 2000,
          progressBar: true,
          tapToDismiss: true,
          positionClass: 'toast-bottom-center',
        });
      }
    });
  }

  noisecatalogshareContent(noiseCatalogId, type, mainGroup, noiseCatalogDisplayNumber) {
    this.noisecatalogshareContentObject = {
      noiseCatalogId: noiseCatalogId,
      type: type,
      mainGroup: mainGroup,
      noiseCatalogDisplayNumber: noiseCatalogDisplayNumber
    };
  }
  ngOnDestroy(): void {
    this.subscription.map(s => s.unsubscribe());
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }
  removeFromNoiseSelection(listType: any, listItem: any) {
    switch (listType) {

      case 'series':
        this.seriesFilterList = this.seriesFilterList.filter(item => item !== listItem.seriesName);
        break;
      case 'area':
        this.areaFilterList = this.areaFilterList.filter(item => item !== listItem.viewValue);
        break;
      case 'component':
        this.componentFilterList = this.componentFilterList.filter(item => item !== listItem.viewValue);
        break;
      case 'drivingCondition':
        this.drivingConditionFilterList = this.drivingConditionFilterList.filter(item => item !== listItem.viewValue);
        break;
      case 'weatherCondition':
        this.weatherConditionFilterList = this.weatherConditionFilterList.filter(item => item !== listItem.viewValue);
        break;
      case 'kindOfNoise':
        this.kindOfNoiseFilterList = this.kindOfNoiseFilterList.filter(item => item !== listItem.viewValue);
        break;
    }
  }


  addToNoiseSelection(listType: any, listItem: any) {
    if (listItem) {
      switch (listType) {
        case 'series':
          this.seriesFilterList.push(listItem.seriesName);
          break;
        case 'area':
          this.areaFilterList.push(listItem.viewValue);
          break;
        case 'component':
          this.componentFilterList.push(listItem.viewValue);
          break;
        case 'drivingCondition':
          this.drivingConditionFilterList.push(listItem.viewValue);
          break;
        case 'weatherCondition':

          // this.kindOfNoiseFilterList.push(listItem.viewValue);
          this.weatherConditionFilterList.push(listItem.viewValue);

          break;
        case 'kindOfNoise':
          this.kindOfNoiseFilterList.push(listItem.viewValue);
          // this.selectedItems = this.kindOfNoiseFilterList;
          break;
        case 'sproadicPermanant':
          this.kindOfNoiseFilterList.push(listItem.viewValue);
          //this.selectedItems = this.kindOfNoiseFilterList;
          break;
      }
    }
  }

}

function filterSeriesArray(array, filter) {
  var myArrayFiltered = [];
  for (var i = 0; i < array.length; i++) {
    for (var j = 0; j < filter.length; j++) {
      if (array[i].id === filter[j].id && array[i].seriesName === filter[j].seriesName) {
        myArrayFiltered.push(array[i].seriesName);
      }
    }
  }
  return myArrayFiltered;
}

function filterSeriesArrayByName(array, filter) {
  var myArrayFiltered = [];
  for (var i = 0; i < array.length; i++) {
    for (var j = 0; j < filter.length; j++) {
      if (array[i].seriesName === filter[j]) {
        myArrayFiltered.push(array[i]);
      }
    }
  }
  return myArrayFiltered;
}